import React from "react";
import PropTypes from "prop-types";
import { Trans } from "react-i18next";
import { COLUMN_MAPPING_STATUS } from "../../constants/columnMappingStatus";
// core imports
import { SFStack } from "../../../components/grid";
import {
  SFWarningIcon,
  SFCheckCircleIcon,
} from "../../../components/icons";
import getStyled from "../../../hooks/getStyled";
import SFTypography from "../../../components/typography";
import { getRGBColorByHex } from "../../../services/colorsService";

const { styled } = getStyled();

const StyledMatchColumn = styled("span", { shouldForwardProp: false })(
  ({ theme, status }) => ({
    fontWeight: 700,
    backgroundColor:
      status === COLUMN_MAPPING_STATUS.MATCHED
        ? getRGBColorByHex(theme.palette.green300.main, 0.2)
        : status === COLUMN_MAPPING_STATUS.POSSIBLY_MATCHED
          ? getRGBColorByHex(theme.palette.orange300.main, 0.2)
          : getRGBColorByHex(theme.palette.red300.main, 0.2),
  })
);

const MatchingLabel = ({ status, srcColName, destColName }) => {
  let label, icon;
  switch (status) {
  case COLUMN_MAPPING_STATUS.MATCHED:
  case COLUMN_MAPPING_STATUS.MANUAL_MATCH:
    label = (
      <Trans
        i18nKey="fileUploadWizard.fileMapping.exactMatchFieldLabel"
        values={{
          fileCol: srcColName,
          expectedCol: destColName,
        }}
        components={{
          style: <StyledMatchColumn status={COLUMN_MAPPING_STATUS.MATCHED} />,
        }}
      />
    );
    icon = <SFCheckCircleIcon size="small" />;
    break;
  case COLUMN_MAPPING_STATUS.POSSIBLY_MATCHED:
    label = (
      <Trans
        i18nKey="fileUploadWizard.fileMapping.possibleMatchFieldLabel"
        values={{
          fileCol: srcColName,
          expectedCol: destColName,
        }}
        components={{
          style: (
            <StyledMatchColumn
              status={COLUMN_MAPPING_STATUS.POSSIBLY_MATCHED}
            />
          ),
        }}
      />
    );
    icon = <SFCheckCircleIcon size="small" color="orange300" />;
    break;
  case COLUMN_MAPPING_STATUS.NO_MATCH:
  default:
    label = (
      <Trans
        i18nKey="fileUploadWizard.fileMapping.noMatchFieldLabel"
        values={{
          expectedCol: destColName,
        }}
        components={{
          style: (
            <StyledMatchColumn status={COLUMN_MAPPING_STATUS.NO_MATCH} />
          ),
        }}
      />
    );
    icon = <SFWarningIcon size="small" />;
    break;
  }
  return (
    <SFStack direction="row" alignItems="center" spacing={2}>
      {icon}
      <SFTypography variant="body1bold">{label}</SFTypography>
    </SFStack>
  );
};

MatchingLabel.propTypes = {
  destColName: PropTypes.string.isRequired,
  srcColName: PropTypes.string,
  status: PropTypes.oneOf(Object.values(COLUMN_MAPPING_STATUS)),
};

export default MatchingLabel;
